// extracted by mini-css-extract-plugin
module.exports = {"root":"SquareSpeciesImage_root__pv_3n","image":"SquareSpeciesImage_image__kJ2Ja"};